import { render, staticRenderFns } from "./HighlightResult.vue?vue&type=template&id=65a2b1b8"
import script from "./HighlightResult.vue?vue&type=script&lang=js"
export * from "./HighlightResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports